import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLayers } from '@agissc/ktag-map';
import { Coordinate } from 'ol/coordinate';
import useAppState from '../../../AppStore';
import IdentifyLayerInfo from './IdentifyLayerInfo';
import IdentifyLayerInfoPlaceholder from './IdentifyLayerInfoPlaceholder';
import { AccordionName } from '../../../UIStateSlice';
import AccordionToggle from '../../../components/accordion/AccordionToggle';
import IdentifyMessageBox from './IdentifyMessageBox';

interface IdentifyLayerInfosProps {
  identifyCoordinate: Coordinate;
  tolerance: number;
}

const IdentifyLayerInfos = ({
  identifyCoordinate,
  tolerance,
}: IdentifyLayerInfosProps) => {
  const { t } = useTranslation('agisviewer');
  const selectedTopicLayers = useAppState((state) => state.selectedTopicLayers);
  const topicLayerSettings = useAppState((state) => state.topicLayerSettings);
  const accordions = useAppState((state) => state.accordions);
  const setAllAccordionItems = useAppState((state) => state.setAllAccordionItems);

  const { isLoading, data } = useLayers();

  if (isLoading) {
    return <IdentifyLayerInfoPlaceholder />;
  }

  const identifyLayerInfo = selectedTopicLayers
    .filter((topicLayerId) => topicLayerSettings[topicLayerId]?.isVisible)
    .filter((topiclayerid) => data[topiclayerid])
    .map((topicId) => {
      const { url, title, isPublic = true, type } = data[topicId];
      return (
        <IdentifyLayerInfo
          key={topicId}
          topicLayerId={topicId}
          url={url}
          isPublic={isPublic}
          layerType={type}
          title={title}
          identifyCoordinate={identifyCoordinate}
          tolerance={tolerance}
        />
      );
    });

  const onToggleAccordionItems = (expanded: boolean) => {
    const ids = accordions[AccordionName.IDENTIFY_CONFIGURATION].map((i) => i.id);
    setAllAccordionItems(AccordionName.IDENTIFY_CONFIGURATION, ids, expanded);
  };

  return (
    <div>
      {identifyLayerInfo.length > 0 ? (
        <AccordionToggle
          onOpen={() => onToggleAccordionItems(true)}
          onClose={() => onToggleAccordionItems(false)}
          tooltipOpen={t('identify_accordion_expand_all_tooltip')}
          tooltipClose={t('identify_accordion_collapse_all_tooltip')}
        />
      ) : (
        <IdentifyMessageBox message={t('identify_nolayer_message')} type="information" />
      )}
      <div className="identifyLayerInfos">{identifyLayerInfo}</div>
    </div>
  );
};

export default IdentifyLayerInfos;
